var map = {
	"./ArticleViewer/index.js": [
		"./src/players/ArticleViewer/index.js"
	],
	"./BookPlayer/index.js": [
		"./src/players/BookPlayer/index.js"
	],
	"./CarouselPlayer/index.js": [
		"./src/players/CarouselPlayer/index.js",
		"CarouselPlayer-index-js"
	],
	"./ChatbotPlayer/index.js": [
		"./src/players/ChatbotPlayer/index.js"
	],
	"./ImageViewer/index.js": [
		"./src/players/ImageViewer/index.js"
	],
	"./JournalPlayer/index.js": [
		"./src/players/JournalPlayer/index.js",
		"JournalPlayer-index-js"
	],
	"./ModalTabletViewer/index.js": [
		"./src/players/ModalTabletViewer/index.js",
		"ModalTabletViewer-index-js"
	],
	"./ModelPlayer/index.js": [
		"./src/players/ModelPlayer/index.js"
	],
	"./PDFViewer/index.js": [
		"./src/players/PDFViewer/index.js",
		"PDFViewer-index-js"
	],
	"./PodcastPlayer/index.js": [
		"./src/players/PodcastPlayer/index.js",
		"PodcastPlayer-index-js"
	],
	"./PosterViewer/index.js": [
		"./src/players/PosterViewer/index.js"
	],
	"./QuizPlayer/index.js": [
		"./src/players/QuizPlayer/index.js",
		"QuizPlayer-index-js"
	],
	"./StreamYardPlayer/index.js": [
		"./src/players/StreamYardPlayer/index.js",
		"StreamYardPlayer-index-js"
	],
	"./TabletViewer/index.js": [
		"./src/players/TabletViewer/index.js"
	],
	"./VideoPlayer/index.js": [
		"./src/players/VideoPlayer/index.js"
	],
	"./WebViewer/index.js": [
		"./src/players/WebViewer/index.js"
	],
	"./YouTubePlayer/index.js": [
		"./src/players/YouTubePlayer/index.js",
		"YouTubePlayer-index-js"
	],
	"./iSpringPlayer/index.js": [
		"./src/players/iSpringPlayer/index.js",
		"iSpringPlayer-index-js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/players lazy recursive ^\\.\\/.*\\/index\\.js$";
module.exports = webpackAsyncContext;